declare global {
  // tslint:disable-next-line: interface-name
  interface Window {
    dataLayer: any
  }
}

export const addGtm = () => {
  const headGtm = document.createElement('script')
  headGtm.innerHTML = `(function (w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f = d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j, f); })(window,document,'script','dataLayer','GTM-P3TWCBK');
 `
  const bodyGtm = document.createElement('noscript')
  bodyGtm.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P3TWCBK" height="0" width="0" style="display:none;visibility:hidden"></iframe>`

  if (process.env.REACT_APP_IS_PROD === 'true') {
    // appends after opening body tag
    const bodyFirstChild = document.body.firstChild
    bodyFirstChild?.parentNode?.insertBefore(bodyGtm, bodyFirstChild)

    // appends after opening head tag
    const headFirstChild = document.head.firstChild
    headFirstChild?.parentNode?.insertBefore(headGtm, headFirstChild)
  }
}

export default {
  addGtm,
  push: (gtmEvent: {
    event?: string | undefined
    category?: string | undefined
    action?: string | undefined
    label?: string | undefined
    context?: string | undefined
    [keys: string]: string | number | undefined
  }) => {
    if (!window.dataLayer) {
      window.dataLayer = []
    }

    window.dataLayer.push({
      event: gtmEvent.event || 'GenericEvent',
      ...gtmEvent
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/googleAnalytics.ts